module.exports = __webpack_public_path__ + "img/low-cost-house-3.e388bf4e.jpg";